import React, {Fragment, useState} from 'react';
import {connect, MapDispatchToProps, MapStateToProps} from 'react-redux';
import {
    Avatar, ClickAwayListener, Tooltip, withStyles,
} from '@material-ui/core';
import {
    ClipLoader
} from 'react-spinners';
import {Initials, isMobileBrowser} from '../../vendors/utils/common';
import {removeAvatar, uploadAvatar} from '../../vendors/actions/user';
import {AvatarEditTooltip} from "../../pages/profile/elements/index";
import {PhotoIcon} from "../../elements/svgIcons"

interface OwnProps {

}

interface ConnectStateProps {
    User: {
        first_name: string;
        last_name: string;
        isAuthenticated?: boolean;
    }
}

interface ConnectDispatchProps {
    uploadAvatar: (data: any) => void;
    removeAvatar: () => void;
}

const CustomTooltip = withStyles({
    tooltip: {
        color: "#3D4977",
        backgroundColor: "#fff",
        opacity: ".9!important",
        padding: "16px 0",
        borderRadius: "10px"
    },
    arrow: {
        color: "#fff"
    }
})(Tooltip);

const AvatarUpload = (props: any) => {
    const {User, Layout} = props,
        {avatarLoading} = Layout,
        [tooltipActive, setTooltipActive] = useState(false);
    let fileInput: any = null;

    const handleTooltipClose = (): void => {

        setTimeout(()=>{
        setTooltipActive(false)},1000);
    };


    const handleTooltipOpen = (): void => setTooltipActive(true);

    const handleChange = (e: any) => {
        const formData = new FormData();
        formData.append("image", e.target.files[0]);
        props.uploadAvatar(formData);
        if (fileInput) {
            fileInput.value = "";
        }
    };
    const removeAvatar = () => {
        if (!User.avatar) return false;
        handleTooltipClose();
        props.removeAvatar();
    };

    return avatarLoading ? (
        <Fragment>
            <Avatar alt={''}
                    className={'d-100'}
                    color={'primary'}
                    src={''}>
                <ClipLoader color={'var(--primary)'} loading={true}/>
            </Avatar>
        </Fragment>
    ) : (
        <Fragment>
            <input
                onChange={(e) => handleChange(e)}
                className={'avatar-selector'}
                accept="image/*"
                ref={ref => fileInput = ref}
                id="avatar-upload"
                type="file"
            />
            <label className='position-relative'>
                <label htmlFor="avatar-upload">
                    <Avatar alt={User.first_name}
                            className='profile-avatar-img'
                            color='primary'
                            src={User.avatar}>
                        {Initials(`${User.first_name} ${User.last_name}`)}
                    </Avatar>
                </label>

                <ClickAwayListener onClickAway={handleTooltipClose}>
                    <CustomTooltip
                        className='profile-avatar-tooltip'
                        title={<AvatarEditTooltip removeAvatar={removeAvatar}/>}
                        placement={isMobileBrowser() ? 'bottom' : 'right'}
                        onClose={handleTooltipClose}
                        open={tooltipActive}
                        disableFocusListener
                        disableHoverListener
                        disableTouchListener
                        arrow
                        interactive
                    >
                        <div onClick={handleTooltipOpen} className="photo-icon">
                            <PhotoIcon style={{fontSize: '24px'}}/>
                        </div>
                    </CustomTooltip>
                </ClickAwayListener>
            </label>
        </Fragment>
    );
};

type ConnectStateMapper = MapStateToProps<ConnectStateProps, OwnProps>

const mapStateToProps: ConnectStateMapper = (state: any) => {
    const {User, Layout} = state;
    return {
        User,
        Layout
    }
};

type ConnectDispatchMapper = MapDispatchToProps<ConnectDispatchProps, OwnProps>

const mapDispatchToProps: ConnectDispatchMapper = (dispatch: any) => {
    return {
        uploadAvatar: (data: any) => dispatch(uploadAvatar(data)),
        removeAvatar: () => dispatch(removeAvatar())
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(AvatarUpload);
